import React from 'react';

import { initYandexMetrica, warn } from '../helpers';

/**
 * Инициализирует счётчик Метрики один раз на переданный id и сообщает,
 * что счётчик готов принимать вызовы (очередь заглушки уже создана).
 *
 * @example
 * const isInitialized = useYandexMetricaInit('21803329');
 */
export const useYandexMetricaInit = (id?: string) => {
  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    if (!id) {
      return;
    }

    try {
      initYandexMetrica({ id });
      setIsInitialized(true);
    } catch (error) {
      warn(`Initialization failed: ${error}`);
    }
  }, [id]);

  return isInitialized;
};
